import 'react-intl-tel-input/dist/main.css';
import './styles.css';

import { forwardRef, useRef } from 'react';

import IntlTelInput from 'react-intl-tel-input';

interface WePhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  borderColor?: string;
  focusBorderColor?: string;
}

const WePhoneInput = forwardRef(
  (
    {
      value,
      onChange,
      className,
      borderColor,
      focusBorderColor,
    }: WePhoneInputProps,
    ref
  ) => {
    const telInputRef = useRef<HTMLInputElement | null>(null);

    const setCursorToEnd = () => {
      const input = telInputRef.current;
      if (input) {
        input.focus();
        requestAnimationFrame(() => {
          const length = input.value.length;
          input.setSelectionRange(length, length);
        });
      }
    };

    return (
      <div
        className={className}
        style={
          {
            '--phone-border-color': borderColor || '#EDEDED',
            '--phone-focus-border-color': focusBorderColor || '#009FE3',
          } as React.CSSProperties
        }
      >
        <IntlTelInput
          preferredCountries={['de']}
          value={value}
          onPhoneNumberChange={(isValid, num, countryData, fullNum) => {
            onChange(fullNum.replace(/\s+/g, ''));
            setCursorToEnd();
          }}
          ref={input => {
            telInputRef.current = input?.tel as HTMLInputElement | null;
          }}
          fieldId="phone"
        />
      </div>
    );
  }
);

WePhoneInput.displayName = 'WePhoneInput';

export default WePhoneInput;
